window.FoxTheme = window.FoxTheme || {};
FoxTheme.config = {
  hasLocalStorage: false,
  mqlMobile: false,
  mqlTablet: false,
  mqlLaptop: false,
  mqlSmallDesktop: false,
  mediaQueryMobile: 'screen and (max-width: 767px)',
  mediaQueryTablet: 'screen and (max-width: 1023px)',
  mediaQueryLaptop: 'screen and (max-width: 1279px)',
  mediaQuerySmallDesktop: 'screen and (max-width: 1535px)',
  motionReduced: window.matchMedia('(prefers-reduced-motion: reduce)').matches,
  isTouch: 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0,
  isRTL: document.documentElement.getAttribute('dir') === 'rtl',
};
console.log(
  '%c' + window.FoxTheme.settings.themeName + ' theme (v' + window.FoxTheme.settings.themeVersion + ') by Foxecom',
  'font-size: 14px; color: #FF5C00;'
);
(function () {
  // 检测本地存储支持
  try {
    const key = 'hyper:test';
    window.localStorage.setItem(key, 'test');
    window.localStorage.removeItem(key);
    FoxTheme.config.hasLocalStorage = true;
  } catch (err) {}

  FoxTheme.DOMready = function (callback) {
    document.readyState != 'loading' ? callback() : document.addEventListener('DOMContentLoaded', callback);
  };

  FoxTheme.a11y = {
    trapFocusHandlers: {},
    getFocusableElements: (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      );
    },
    trapFocus: (container, elementToFocus = container) => {
      // 避免重复设置焦点陷阱
      if (FoxTheme.a11y.trapFocusHandlers.active) return;
      FoxTheme.a11y.trapFocusHandlers.active = true;

      var elements = FoxTheme.a11y.getFocusableElements(container);
      var first = elements[0];
      var last = elements[elements.length - 1];

      FoxTheme.a11y.removeTrapFocus();

      FoxTheme.a11y.trapFocusHandlers.focusin = (event) => {
        if (event.target !== container && event.target !== last && event.target !== first) return;
        document.addEventListener('keydown', FoxTheme.a11y.trapFocusHandlers.keydown);
      };

      FoxTheme.a11y.trapFocusHandlers.focusout = function () {
        document.removeEventListener('keydown', FoxTheme.a11y.trapFocusHandlers.keydown);
      };

      FoxTheme.a11y.trapFocusHandlers.keydown = function (event) {
        if (event.code.toUpperCase() !== 'TAB') return;
        
        if (event.target === last && !event.shiftKey) {
          event.preventDefault();
          first.focus();
        }

        if ((event.target === container || event.target === first) && event.shiftKey) {
          event.preventDefault();
          last.focus();
        }
      };

      document.addEventListener('focusout', FoxTheme.a11y.trapFocusHandlers.focusout);
      document.addEventListener('focusin', FoxTheme.a11y.trapFocusHandlers.focusin);

      elementToFocus.focus();

      if (
        elementToFocus.tagName === 'INPUT' &&
        ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
        elementToFocus.value
      ) {
        elementToFocus.setSelectionRange(0, elementToFocus.value.length);
      }
    },
    removeTrapFocus: (elementToFocus = null) => {
      document.removeEventListener('focusin', FoxTheme.a11y.trapFocusHandlers.focusin);
      document.removeEventListener('focusout', FoxTheme.a11y.trapFocusHandlers.focusout);
      document.removeEventListener('keydown', FoxTheme.a11y.trapFocusHandlers.keydown);
      FoxTheme.a11y.trapFocusHandlers.active = false;

      if (elementToFocus) elementToFocus.focus();
    },
  };

  FoxTheme.utils = {
    // 优化节流函数，防止内存泄漏
    throttle: (callback, limit = 100) => {
      let requestId = null,
        lastArgs,
        lastExec = 0;
        
      const later = (context) => () => {
        const now = Date.now();
        if (now - lastExec >= limit) {
          lastExec = now;
          callback.apply(context, lastArgs);
        }
        requestId = null;
      };
      
      const throttled = (...args) => {
        lastArgs = args;
        if (requestId === null) {
          requestId = requestAnimationFrame(later(this));
        }
      };
      
      throttled.cancel = () => {
        cancelAnimationFrame(requestId);
        requestId = null;
      };
      
      return throttled;
    },
    
    setScrollbarWidth: () => {
      const scrollbarWidth = window.innerWidth - document.body.clientWidth;
      scrollbarWidth > 0 && document.documentElement.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);
    },
    
    waitForEvent: (element, eventName) => {
      return new Promise((resolve) => {
        const eventHandler = (event) => {
          if (event.target === element) {
            element.removeEventListener(eventName, eventHandler);
            resolve(event);
          }
        };
        element.addEventListener(eventName, eventHandler);
      });
    },
    
    // 优化DOM查询性能
    queryDomNodes: (selectors = {}, context = document) => {
      const domNodes = Object.entries(selectors).reduce((acc, [name, selector]) => {
        const findOne = typeof selector === 'string';
        const queryMethod = findOne ? 'querySelector' : 'querySelectorAll';
        const sl = findOne ? selector : selector[0];

        acc[name] = context && context[queryMethod](sl);
        if (!findOne && acc[name]) {
          acc[name] = [...acc[name]];
        }
        return acc;
      }, {});
      return domNodes;
    },
    
    // 事件委托优化
    addEventDelegate: ({ context = document.documentElement, event = 'click', selector, handler, capture = false }) => {
      const listener = function (e) {
        for (let target = e.target; target && target !== this; target = target.parentNode) {
          if (target.matches(selector)) {
            handler.call(target, e, target);
            break;
          }
        }
      };
      context.addEventListener(event, listener, capture);
      return () => {
        context.removeEventListener(event, listener, capture);
      };
    },
    
    getSectionId: (element) => {
      if (element.hasAttribute('data-section-id')) {
        return element.dataset.sectionId;
      } else {
        if (!element.classList.contains('shopify-section')) {
          element = element.closest('.shopify-section');
        }
        return element.id.replace('shopify-section-', '');
      }
    },
    
    debounce: (fn, wait) => {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    },
    
    fetchConfig: (type = 'json') => {
      return {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
      };
    },
    
    setStorage(key, value, expiryInDays = null) {
      if (!FoxTheme.config.hasLocalStorage) return;

      const item = { value: value };

      if (expiryInDays !== null) {
        const now = new Date();
        item.expiry = now.getTime() + expiryInDays * 86400000;
      }

      try {
        window.localStorage.setItem(key, JSON.stringify(item));
      } catch (e) {
        console.warn('Local storage limit reached, cannot save item:', key);
      }
    },
    
    getStorage(key) {
      if (!FoxTheme.config.hasLocalStorage) return null;

      const itemStr = window.localStorage.getItem(key);
      if (!itemStr) return null;
      
      try {
        const item = JSON.parse(itemStr);
        if (item.expiry && new Date().getTime() > item.expiry) {
          window.localStorage.removeItem(key);
          return null;
        }
        return item.value;
      } catch (e) {
        window.localStorage.removeItem(key);
        return null;
      }
    },
    
    postLink: (path, options) => {
      options = options || {};
      const method = options['method'] || 'post';
      const params = options['parameters'] || {};

      const form = document.createElement('form');
      form.setAttribute('method', method);
      form.setAttribute('action', path);

      for (const key in params) {
        for (const index in params[key]) {
          for (const key2 in params[key][index]) {
            const hiddenField = document.createElement('input');
            hiddenField.setAttribute('type', 'hidden');
            hiddenField.setAttribute('name', `${key}[${index}][${key2}]`);
            hiddenField.setAttribute('value', params[key][index][key2]);
            form.appendChild(hiddenField);
          }
        }
      }
      document.body.appendChild(form);
      form.submit();
      document.body.removeChild(form);
    },
    
    // 图片加载优化
    imageReady: (imageOrArray) => {
      if (!imageOrArray) return Promise.resolve();
      
      imageOrArray = imageOrArray instanceof Element ? [imageOrArray] : Array.from(imageOrArray);
      const images = imageOrArray.filter(el => el.tagName === 'IMG');
      
      if (images.length === 0) return Promise.resolve();
      
      return Promise.all(
        images.map((image) => {
          return new Promise((resolve) => {
            if (image.complete) {
              resolve();
              return;
            }
            
            const onLoad = () => {
              image.removeEventListener('load', onLoad);
              image.removeEventListener('error', onLoad);
              resolve();
            };
            
            image.addEventListener('load', onLoad);
            image.addEventListener('error', onLoad);
          });
        })
      );
    },
    
    displayedMedia: (media) => {
      return Array.from(media).find((item) => {
        const style = window.getComputedStyle(item);
        return style.display !== 'none';
      });
    },
  };

  FoxTheme.pubsub = {
    PUB_SUB_EVENTS: {
      cartUpdate: 'cart-update',
      quantityUpdate: 'quantity-update',
      quantityRules: 'quantity-rules',
      quantityBoundries: 'quantity-boundries',
      variantChange: 'variant-change',
      cartError: 'cart-error',
      facetUpdate: 'facet-update',
      optionValueSelectionChange: 'option-value-selection-change',
    },
    subscribers: {},
    subscribe: (eventName, callback) => {
      if (!FoxTheme.pubsub.subscribers[eventName]) {
        FoxTheme.pubsub.subscribers[eventName] = [];
      }

      FoxTheme.pubsub.subscribers[eventName].push(callback);

      return function unsubscribe() {
        FoxTheme.pubsub.subscribers[eventName] = FoxTheme.pubsub.subscribers[eventName].filter(cb => cb !== callback);
      };
    },

    publish: (eventName, data) => {
      if (FoxTheme.pubsub.subscribers[eventName]) {
        // 复制数组防止发布时订阅者被修改
        [...FoxTheme.pubsub.subscribers[eventName]].forEach(callback => callback(data));
      }
    },
  };

  FoxTheme.focusVisiblePolyfill = function () {
    const navKeys = [
      'ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 
      'TAB', 'ENTER', 'SPACE', 'ESCAPE', 
      'HOME', 'END', 'PAGEUP', 'PAGEDOWN'
    ];
    let currentFocusedElement = null;
    let mouseClick = null;

    const handleKeydown = (event) => {
      if (navKeys.includes(event.code.toUpperCase())) {
        mouseClick = false;
      }
    };

    const handleMousedown = () => {
      mouseClick = true;
    };

    const handleFocus = () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    };

    window.addEventListener('keydown', handleKeydown);
    window.addEventListener('mousedown', handleMousedown);
    window.addEventListener('focus', handleFocus, true);

    // 清理函数
    return () => {
      window.removeEventListener('keydown', handleKeydown);
      window.removeEventListener('mousedown', handleMousedown);
      window.removeEventListener('focus', handleFocus, true);
    };
  };

  FoxTheme.Carousel = (function () {
    class Carousel {
      constructor(container, options, modules = null) {
        this.container = container;
        let defaultModules = [FoxTheme.Swiper.Navigation, FoxTheme.Swiper.Pagination, FoxTheme.Swiper.A11y];
        if (modules) {
          defaultModules = defaultModules.concat(modules);
        }
        this.options = {
          modules: defaultModules,
          ...options,
        };
        this.slider = null;
      }

      // 延迟初始化直到元素可见
      initWhenVisible() {
        if (this.slider) return;
        
        const observer = new IntersectionObserver((entries) => {
          if (entries[0].isIntersecting) {
            this.init();
            observer.disconnect();
          }
        }, { threshold: 0.1 });
        
        observer.observe(this.container);
      }

      init() {
        if (this.slider) return;
        
        // 检查容器是否有足够的子元素
        const slides = this.container.querySelectorAll('.swiper-slide');
        if (slides.length <= 1 && !this.options.loop) {
          return; // 只有一个 slide 时不初始化轮播
        }
        
        this.slider = new FoxTheme.Swiper.Swiper(this.container, this.options);
      }
    }
    return Carousel;
  })();

  FoxTheme.delayUntilInteraction = (function () {
    class ScriptLoader {
      constructor(callback, delay = 5000) {
        this.loadScriptTimer = setTimeout(callback, delay);
        this.userInteractionEvents = [
          'mouseover', 'mousemove', 'keydown', 
          'touchstart', 'touchend', 'touchmove', 'wheel'
        ];

        this.onScriptLoader = this.triggerScriptLoader.bind(this, callback);
        this.userInteractionEvents.forEach(event => {
          window.addEventListener(event, this.onScriptLoader, { passive: true, once: true });
        });
      }

      triggerScriptLoader(callback) {
        callback();
        clearTimeout(this.loadScriptTimer);
        this.userInteractionEvents.forEach(event => {
          window.removeEventListener(event, this.onScriptLoader);
        });
      }
    }

    return ScriptLoader;
  })();

  FoxTheme.Currency = (function () {
    const moneyFormat = '${{amount}}';

    function formatMoney(cents, format) {
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      let value = '';
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const formatString = format || moneyFormat;

      function formatWithDelimiters(number, precision, thousands, decimal) {
        thousands = thousands || ',';
        decimal = decimal || '.';

        if (isNaN(number) || number === null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        const parts = number.split('.');
        const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        const centsAmount = parts[1] ? decimal + parts[1] : '';

        return dollarsAmount + centsAmount;
      }

      const match = formatString.match(placeholderRegex);
      if (!match) return '';

      switch (match[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
        case 'amount_with_apostrophe_separator':
          value = formatWithDelimiters(cents, 2, "'");
          break;
      }

      return formatString.replace(placeholderRegex, value);
    }

    function getBaseUnit(variant) {
      if (!variant) return;

      if (!variant.unit_price_measurement || !variant.unit_price_measurement.reference_value) {
        return;
      }

      return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value + variant.unit_price_measurement.reference_unit;
    }

    return {
      formatMoney: formatMoney,
      getBaseUnit: getBaseUnit,
    };
  })();

  // 延迟初始化非关键UI
  new FoxTheme.delayUntilInteraction(() => {
    document.body.removeAttribute('data-initializing');
  }, 3000);

  FoxTheme.DOMready(FoxTheme.utils.setScrollbarWidth);
  const resizeThrottled = FoxTheme.utils.throttle(FoxTheme.utils.setScrollbarWidth, 100);
  window.addEventListener('resize', resizeThrottled);

  // 媒体查询优化 - 使用统一的处理函数
  function setupMediaQuery(query, configKey, matchEvent, unmatchEvent) {
    const mql = window.matchMedia(query);
    FoxTheme.config[configKey] = mql.matches;
    
    const handleChange = (event) => {
      FoxTheme.config[configKey] = event.matches;
      document.dispatchEvent(new CustomEvent(event.matches ? matchEvent : unmatchEvent));
    };
    
    mql.addEventListener('change', handleChange);
    return handleChange;
  }

  setupMediaQuery(FoxTheme.config.mediaQueryMobile, 'mqlMobile', 'matchMobile', 'unmatchMobile');
  setupMediaQuery(FoxTheme.config.mediaQueryTablet, 'mqlTablet', 'matchTablet', 'unmatchTablet');
  setupMediaQuery(FoxTheme.config.mediaQueryLaptop, 'mqlLaptop', 'matchLaptop', 'unmatchLaptop');
  setupMediaQuery(FoxTheme.config.mediaQuerySmallDesktop, 'mqlSmallDesktop', 'matchSmallDesktop', 'unmatchSmallDesktop');
})();

// focus-visible  polyfill 优化
let focusPolyfillCleanup;
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusPolyfillCleanup = FoxTheme.focusVisiblePolyfill();
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach(video => {
    video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach(video => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach(video => video.pause());
  document.querySelectorAll('product-model').forEach(model => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

class HTMLUpdateUtility {
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    if (!oldNode || !newContent) return;
    preProcessCallbacks?.forEach(callback => callback(newContent));

    const newNodeWrapper = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // 去重ID
    const uniqueKey = Date.now();
    oldNode.querySelectorAll('[id], [form]').forEach(element => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';

    postProcessCallbacks?.forEach(callback => callback(newNode));

    // 使用requestAnimationFrame确保视觉更新完成
    requestAnimationFrame(() => {
      setTimeout(() => oldNode.remove(), 500);
    });
  }

  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach(oldScriptTag => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach(attribute => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

class PageTransition extends HTMLElement {
  constructor() {
    super();

    const handleBeforeUnload = () => {
      document.body.classList.add('page-loading');
    };

    const handleDOMContentLoaded = () => {
      if (FoxTheme.Motion) {
        FoxTheme.Motion.animate(this, { visibility: 'hidden', opacity: 0 }, { duration: 1 });
      } else {
        this.style.visibility = 'hidden';
        this.style.opacity = 0;
      }

      document.body.classList.add('page-loaded');
      document.dispatchEvent(new CustomEvent('page:loaded'));
    };

    const handlePageshow = (event) => {
      if (event.persisted) {
        document.body.classList.remove('page-loading');
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    window.addEventListener('DOMContentLoaded', handleDOMContentLoaded);
    window.addEventListener('pageshow', handlePageshow);

    // 清理函数
    this.cleanup = () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('DOMContentLoaded', handleDOMContentLoaded);
      window.removeEventListener('pageshow', handlePageshow);
    };
  }

  disconnectedCallback() {
    this.cleanup();
  }
}
customElements.define('page-transition', PageTransition);

const clearModalComponentCount = new WeakMap();
class ModalComponent extends HTMLElement {
  constructor() {
    super();
    this.events = {
      handleAfterHide: 'modal:handleAfterHide',
      handleAfterShow: 'modal:handleAfterShow',
    };

    this.classes = {
      show: 'modal-show',
      showing: 'modal-showing',
    };
    this.abortController = null;
  }

  static get observedAttributes() {
    return ['id', 'open'];
  }

  get isLockingNeeded() {
    return false;
  }

  get requiresBodyAppended() {
    return false;
  }

  get controls() {
    return Array.from(document.querySelectorAll(`[aria-controls="${this.id}"]`));
  }

  get designMode() {
    return this.hasAttribute('shopify-design-mode');
  }

  get open() {
    return this.hasAttribute('open');
  }

  get overlay() {
    if (!this._overlay) {
      this._overlay = this.querySelector('.fixed-overlay');
    }
    return this._overlay;
  }

  get focusElement() {
    const button = this.querySelector('button');
    if (button) return button;
    
    const focusableElements = FoxTheme.a11y.getFocusableElements(this);
    return focusableElements[0] || this;
  }

  connectedCallback() {
    this.abortController = new AbortController();

    this.controls.forEach(button => {
      button.addEventListener('click', this.onButtonClick.bind(this), {
        signal: this.abortController.signal,
      });
    });

    document.addEventListener(
      'keyup',
      (event) => {
        if (event.code === 'Escape') {
          this.hide();
        }
      },
      { signal: this.abortController.signal }
    );

    if (this.designMode && Shopify.designMode) {
      const section = this.closest('.shopify-section');
      section.addEventListener(
        'shopify:section:select',
        (event) => {
          this.show(null, !event.detail.load);
        },
        { signal: this.abortController.signal }
      );
      section.addEventListener(
        'shopify:section:deselect',
        () => {
          this.hide();
        },
        { signal: this.abortController.signal }
      );
    }
  }

  disconnectedCallback() {
    if (this.abortController) {
      this.abortController.abort();
    }
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'open') {
      this.controls.forEach(button => 
        button.setAttribute('aria-expanded', newValue === null ? 'false' : 'true')
      );

      if (oldValue === null && (newValue === '' || newValue === 'immediate')) {
        this.hidden = false;
        this.removeAttribute('inert');

        this.parentElementBeforeAppend = null;
        if (this.requiresBodyAppended && this.parentElement !== document.body) {
          this.parentElementBeforeAppend = this.parentElement;
          document.body.append(this);
        }
        const handleShowTransitionPromise = this.handleShowTransition(newValue !== 'immediate') || Promise.resolve();
        handleShowTransitionPromise.then(() => {
          this.handleAfterShow();
          this.dispatchEvent(new CustomEvent(this.events.handleAfterShow, { bubbles: true }));
        });
      } else if (oldValue !== null && newValue === null) {
        this.setAttribute('inert', '');

        const handleHideTransitionPromise = this.handleHideTransition() || Promise.resolve();
        handleHideTransitionPromise.then(() => {
          this.handleAfterHide();

          if (!this.hasAttribute('inert')) return;

          if (this.parentElement === document.body && this.parentElementBeforeAppend) {
            this.parentElementBeforeAppend.appendChild(this);
            this.parentElementBeforeAppend = null;
          }
          this.dispatchEvent(new CustomEvent(this.events.handleAfterHide, { bubbles: true }));

          this.hidden = true;
        });
      }
      this.dispatchEvent(new CustomEvent('toggle', { bubbles: true }));
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    if (event.currentTarget.disabled) return;

    if (this.open) {
      this.hide();
    } else {
      this.show(event.currentTarget);
    }
  }

  hide() {
    if (this.open) {
      this.removeAttribute('open');
      return FoxTheme.utils.waitForEvent(this, this.events.handleAfterHide);
    }
  }

  show(activeElement = null, animate = true) {
    if (!this.shouleBeShow()) return;

    if (!this.open) {
      this.prepareToShow();
      this.activeElement = activeElement;
      this.setAttribute('open', animate ? '' : 'immediate');

      if (this.isLockingNeeded) {
        document.body.classList.add(this.classes.showing);
      }

      return FoxTheme.utils.waitForEvent(this, this.events.handleAfterShow);
    }
  }

  handleAfterHide() {
    setTimeout(() => {
      FoxTheme.a11y.removeTrapFocus(this.activeElement);

      if (this.isLockingNeeded) {
        const currentModalCount = (clearModalComponentCount.get(ModalComponent) || 0) - 1;
        clearModalComponentCount.set(ModalComponent, currentModalCount);
        document.body.classList.toggle(this.classes.show, currentModalCount > 0);
      }
    });
  }

  handleAfterShow() {
    if (!Shopify.designMode) {
      FoxTheme.a11y.trapFocus(this, this.focusElement);
    }

    if (this.isLockingNeeded) {
      const currentLockCount = (clearModalComponentCount.get(ModalComponent) || 0) + 1;
      clearModalComponentCount.set(ModalComponent, currentLockCount);
      document.body.classList.remove(this.classes.showing);
      document.body.classList.add(this.classes.show);
    }
  }

  shouleBeShow() {
    return true;
  }

  prepareToShow() {}

  handleShowTransition() {
    setTimeout(() => {
      this.setAttribute('active', '');
    }, 75);

    return new Promise(resolve => {
      if (!this.overlay) {
        resolve();
        return;
      }
      const onTransitionEnd = () => {
        this.overlay.removeEventListener('transitionend', onTransitionEnd);
        resolve();
      };
      this.overlay.addEventListener('transitionend', onTransitionEnd, { once: true });
    });
  }

  handleHideTransition() {
    this.removeAttribute('active');

    return new Promise(resolve => {
      if (!this.overlay) {
        resolve();
        return;
      }
      const onTransitionEnd = () => {
        this.overlay.removeEventListener('transitionend', onTransitionEnd);
        resolve();
      };
      this.overlay.addEventListener('transitionend', onTransitionEnd, { once: true });
    });
  }
}
customElements.define('modal-component', ModalComponent);
clearModalComponentCount.set(ModalComponent, 0);

class BasicModal extends ModalComponent {
  constructor() {
    super();
  }

  get isLockingNeeded() {
    return true;
  }

  get requiresBodyAppended() {
    return true;
  }
}
customElements.define('basic-modal', BasicModal);

class DrawerComponent extends ModalComponent {
  constructor() {
    super();
    this.events = {
      handleAfterHide: 'drawer:handleAfterHide',
      handleAfterShow: 'drawer:handleAfterShow',
    };
  }
  
  get isLockingNeeded() {
    return true;
  }
  
  get requiresBodyAppended() {
    return true;
  }
}
customElements.define('drawer-component', DrawerComponent);

class SpotlightPick extends DrawerComponent {
  constructor() {
    super();
  }

  get requiresBodyAppended() {
    return false;
  }

  get toggleButton() {
    return this.controls.find(control => control.hasAttribute('data-toggle-spotlight'));
  }

  connectedCallback() {
    super.connectedCallback();

    if (this.toggleButton) {
      this.toggleTeaser(this.toggleButton, false, 0);
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const { target, currentTarget } = event;
    if (target.hasAttribute('data-close-teaser')) {
      this.toggleTeaser(this.toggleButton, true);
      return;
    }

    super.onButtonClick(event);
  }

  toggleTeaser(toggleEl, shouldHide, hideDurationHours = 4) {
    const currentTime = new Date().getTime();
    const hideDuration = hideDurationHours * 60 * 60 * 1000;

    if (shouldHide) {
      toggleEl.classList.add('hidden');
      FoxTheme.utils.setStorage('spotlight:teaserHidden', 'true', hideDurationHours / 24);
      FoxTheme.utils.setStorage('spotlight:teaserHideTime', currentTime.toString(), hideDurationHours / 24);
      FoxTheme.utils.setStorage('spotlight:teaserHideDuration', hideDuration.toString(), hideDurationHours / 24);
    } else {
      const teaserHidden = FoxTheme.utils.getStorage('spotlight:teaserHidden');
      const teaserHideTime = FoxTheme.utils.getStorage('spotlight:teaserHideTime');
      const teaserHideDuration = FoxTheme.utils.getStorage('spotlight:teaserHideDuration');

      if (teaserHidden === 'true' && teaserHideTime) {
        const timeElapsed = currentTime - parseInt(teaserHideTime);

        if (timeElapsed < parseInt(teaserHideDuration)) {
          toggleEl.classList.add('hidden');
        } else {
          FoxTheme.utils.setStorage('spotlight:teaserHidden', null);
          FoxTheme.utils.setStorage('spotlight:teaserHideTime', null);
          FoxTheme.utils.setStorage('spotlight:teaserHideDuration', null);
          toggleEl.classList.remove('hidden');
        }
      } else {
        toggleEl.classList.remove('hidden');
      }
    }
  }
}
customElements.define('spotlight-pick', SpotlightPick);

class AccordionDetails extends HTMLDetailsElement {
  constructor() {
    super();
    this.initAccordion();
    this.animationFrame = null;
  }

  initAccordion() {
    this.isOpen = this.hasAttribute('open');
    this.summaryElement = this.querySelector('summary');
    this.contentElement = this.querySelector('summary + *');
    this.setAttribute('aria-expanded', this.isOpen ? 'true' : 'false');

    this.summaryElement.addEventListener('click', this.toggleAccordion.bind(this));

    if (Shopify.designMode) {
      this.designModeEventSetup();
    }
  }

  static get observedAttributes() {
    return ['open'];
  }

  get open() {
    return this.isOpen;
  }

  set open(value) {
    if (value !== this.isOpen) {
      this.isOpen = value;

      if (this.isConnected) {
        this.animateAccordion(value);
      } else {
        if (value) {
          this.setAttribute('open', '');
        } else {
          this.removeAttribute('open');
        }
      }

      this.setAttribute('aria-expanded', value ? 'true' : 'false');
      this.setAttribute('aria-controls', this.contentElement?.id || '');

      this.handleAfterToggle();
    }
  }

  handleAfterToggle() {}

  toggleAccordion(event) {
    event.preventDefault();
    this.open = !this.open;
  }

  close() {
    this.isOpen = false;
    this.animateAccordion(false);
  }

  async animateAccordion(isOpen) {
    // 取消上一次的动画帧
    if (this.animationFrame) {
      cancelAnimationFrame(this.animationFrame);
    }

    this.style.overflow = 'hidden';

    if (isOpen) {
      this.setAttribute('open', '');
      this.parentElement.classList.add('active');

      await FoxTheme.Motion?.timeline([
        [
          this,
          { height: [`${this.summaryElement.clientHeight + 1}px`, `${this.scrollHeight + 1}px`] },
          { duration: 0.25, easing: 'ease' },
        ],
        [
          this.contentElement,
          { opacity: [0, 1], transform: ['translateY(10px)', 'translateY(0)'] },
          { duration: 0.15, at: '<' },
        ],
      ])?.finished;
    } else {
      await FoxTheme.Motion?.timeline([
        [this.contentElement, { opacity: 0 }, { duration: 0.15 }],
        [
          this,
          { height: [`${this.clientHeight + 1}px`, `${this.summaryElement.clientHeight + 1}px`] },
          { duration: 0.25, at: '<', easing: 'ease' },
        ],
      ])?.finished;

      this.removeAttribute('open');
      this.parentElement.classList.remove('active');
    }

    this.style.height = 'auto';
    this.style.overflow = 'visible';
  }

  designModeEventSetup() {
    this.addEventListener('shopify:block:select', () => {
      this.open = true;
    });

    this.addEventListener('shopify:block:deselect', () => {
      this.open = false;
    });
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'open') {
      this.setAttribute('aria-controls', this.contentElement?.id || '');
    }
  }
}
customElements.define('accordion-details', AccordionDetails, { extends: 'details' });

class AccordionGroup extends AccordionDetails {
  constructor() {
    super();
  }

  handleAfterToggle() {
    if (this.isOpen) {
      const parent = this.closest('.accordion-parent') || document;
      const siblingsAccordions = parent.querySelectorAll('details[is="accordion-group"]');

      siblingsAccordions.forEach(details => {
        if (details !== this) {
          details.open = false;
        }
      });
    }
  }
}
customElements.define('accordion-group', AccordionGroup, { extends: 'details' });

class ProgressBar extends HTMLElement {
  constructor() {
    super();

    if (this.hasAttribute('style')) return;

    if (this.dataset.from) {
      this.initProgress();
    }

    FoxTheme.Motion?.inView(this, this.init.bind(this));
  }

  init() {
    this.setPercentage(this.dataset.value, this.dataset.max);
  }

  initProgress() {
    this.setPercentage(this.dataset.from, this.dataset.max);
  }

  setPercentage(val1, val2) {
    if (!val1 || !val2) return;
    this.style.setProperty('--percent', `${(parseInt(val1) / parseInt(val2)) * 100}%`);
  }
}
customElements.define('progress-bar', ProgressBar);

class CartCount extends HTMLElement {
  constructor() {
    super();
    this.cartUpdateUnsubscriber = null;
  }

  connectedCallback() {
    this.cartUpdateUnsubscriber = FoxTheme.pubsub.subscribe(
      FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate,
      this.onCartUpdate.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  get itemCount() {
    return parseInt(this.innerText);
  }

  get type() {
    return this.dataset.type;
  }

  onCartUpdate(event) {
    if (event?.cart?.errors) return;
    if (!event?.cart) return;

    let count = event.cart.item_count > 99 ? '99+' : event.cart.item_count;

    if (this.type === 'blank') {
      count = `(${count})`;
    }

    if (this.classList.contains('cart-count--absolute')) {
      if (event.cart.item_count > 99) {
        this.innerHTML = `<span class="text-sm-extra">${count}</span>`;
        this.classList.add('cart-count--small-medium');
      } else {
        this.innerText = count;
        this.classList.remove('cart-count--small-medium');
      }
    } else {
      this.innerText = count;
    }

    this.hidden = this.itemCount === 0 || event.cart.item_count === 0;

    const method = this.itemCount === 0 ? 'remove' : 'add';
    document.documentElement.classList[method]('cart-has-items');
  }
}
customElements.define('cart-count', CartCount);

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.quantityUpdateUnsubscriber = null;
    this.quantityBoundriesUnsubscriber = null;
    this.quantityRulesUnsubscriber = null;
    this.abortController = null;
  }

  get sectionId() {
    return this.getAttribute('data-section-id');
  }

  get productId() {
    return this.getAttribute('data-product-id');
  }

  get input() {
    return this.querySelector('input');
  }

  get value() {
    return this.input?.value;
  }

  connectedCallback() {
    this.abortController = new AbortController();

    this.buttons = Array.from(this.querySelectorAll('button'));
    this.changeEvent = new Event('change', { bubbles: true });

    if (this.input) {
      this.input.addEventListener('change', this.onInputChange.bind(this));
      this.input.addEventListener('focus', () => setTimeout(() => this.input.select()));
    }

    this.buttons.forEach(button => 
      button.addEventListener('click', this.onButtonClick.bind(this), {
        signal: this.abortController.signal,
      })
    );

    this.validateQtyRules();

    this.quantityUpdateUnsubscriber = FoxTheme.pubsub.subscribe(
      FoxTheme.pubsub.PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
    this.quantityBoundriesUnsubscriber = FoxTheme.pubsub.subscribe(
      FoxTheme.pubsub.PUB_SUB_EVENTS.quantityBoundries,
      this.setQuantityBoundries.bind(this)
    );
    this.quantityRulesUnsubscriber = FoxTheme.pubsub.subscribe(
      FoxTheme.pubsub.PUB_SUB_EVENTS.quantityRules,
      this.updateQuantityRules.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.abortController) {
      this.abortController.abort();
    }

    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
    if (this.quantityBoundriesUnsubscriber) {
      this.quantityBoundriesUnsubscriber();
    }
    if (this.quantityRulesUnsubscriber) {
      this.quantityRulesUnsubscriber();
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    if (!this.input) return;

    const previousValue = this.input.value;

    if (event.currentTarget.name === 'plus') {
      if (parseInt(this.input.getAttribute('data-min') || 1) > parseInt(this.input.step || 1) && this.input.value == 0) {
        this.input.value = this.input.getAttribute('data-min');
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent);
    }

    if (this.input.getAttribute('data-min') === previousValue && event.currentTarget.name === 'minus') {
      this.input.value = parseInt(this.input.min || 1);
    }
  }

  onInputChange() {
    if (!this.input) return;
    
    if (this.input.value === '') {
      this.input.value = parseInt(this.input.min || 1);
    }
    this.validateQtyRules();
  }

  validateQtyRules() {
    if (!this.input) return;
    
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector('button[name="minus"]');
      if (buttonMinus) {
        buttonMinus.toggleAttribute('disabled', parseInt(value) <= parseInt(this.input.min));
      }
    }
    if (this.input.max) {
      const buttonPlus = this.querySelector('button[name="plus"]');
      if (buttonPlus) {
        buttonPlus.toggleAttribute('disabled', parseInt(value) >= parseInt(this.input.max));
      }
    }
  }

  updateQuantityRules({ data: { sectionId, productId, parsedHTML } }) {
    if (sectionId !== this.sectionId || productId !== this.productId) return;
    if (!parsedHTML) return;

    const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
    const quantityFormUpdated = parsedHTML.getElementById(`QuantityForm-${sectionId}`);
    const quantityForm = this.closest(`#QuantityForm-${sectionId}`);
    
    if (!quantityForm || !quantityFormUpdated) return;
    
    for (let selector of selectors) {
      const current = quantityForm.querySelector(selector);
      const updated = quantityFormUpdated.querySelector(selector);
      if (!current || !updated) continue;

      if (selector === '.quantity__input') {
        const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
        for (let attribute of attributes) {
          const valueUpdated = updated.getAttribute(attribute);
          if (valueUpdated !== null) {
            current.setAttribute(attribute, valueUpdated);
          } else {
            current.removeAttribute(attribute);
          }
        }
      } else {
        current.innerHTML = updated.innerHTML;
      }
    }
  }

  setQuantityBoundries({ data: { sectionId, productId } }) {
    if (sectionId !== this.sectionId || productId !== this.productId) return;
    if (!this.input) return;

    const data = {
      cartQuantity: this.input.hasAttribute('data-cart-quantity')
        ? parseInt(this.input.getAttribute('data-cart-quantity'))
        : 0,
      min: this.input.hasAttribute('data-min') ? parseInt(this.input.getAttribute('data-min')) : 1,
      max: this.input.hasAttribute('data-max') ? parseInt(this.input.getAttribute('data-max')) : null,
      step: this.input.hasAttribute('step') ? parseInt(this.input.getAttribute('step')) : 1,
    };

    let min = data.min;
    const max = data.max === null ? data.max : data.max - data.cartQuantity;
    if (max !== null) min = Math.min(min, max);
    if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

    this.input.min = min;

    if (max) {
      this.input.max = max;
    } else {
      this.input.removeAttribute('max');
    }
    this.input.value = min;

    FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.quantityUpdate, undefined);
  }
}
customElements.define('quantity-input', QuantityInput);

class QuantitySelector extends HTMLElement {
  constructor() {
    super();
    this.abortController = null;
  }

  connectedCallback() {
    this.abortController = new AbortController();

    this.input = this.querySelector('input');
    this.buttons = Array.from(this.querySelectorAll('button'));
    this.changeEvent = new Event('change', { bubbles: true });

    this.buttons.forEach(button => 
      button.addEventListener('click', this.onButtonClick.bind(this), {
        signal: this.abortController.signal,
      })
    );
  }

  disconnectedCallback() {
    if (this.abortController) {
      this.abortController.abort();
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    if (!this.input) return;

    const previousValue = this.input.value;

    if (event.currentTarget.name === 'plus') {
      this.input.quantity = this.input.quantity + 1;
    } else {
      this.input.quantity = this.input.quantity - 1;
    }

    if (previousValue !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent);
    }
  }
}
customElements.define('quantity-selector', QuantitySelector);

const onYouTubeApiLoaded = new Promise(resolve => {
  window.onYouTubeIframeAPIReady = () => resolve();
});

class VideoElement extends HTMLElement {
  constructor() {
    super();
    this.playerProxy = null;
    this.paused = true;
    this.iframe = null;
  }

  get posterElement() {
    return this.querySelector('[id^="DeferredPoster-"]');
  }

  get controlledElement() {
    return this.hasAttribute('aria-controls') ? document.getElementById(this.getAttribute('aria-controls')) : null;
  }

  get autoplay() {
    return this.hasAttribute('autoplay');
  }

  get playing() {
    return this.hasAttribute('playing');
  }

  get player() {
    return (this.playerProxy = this.playerProxy || new Proxy(this.initializePlayer(), {
      get: (target, prop) => {
        return async () => {
          target = await target;
          this.handlePlayerAction(target, prop);
        };
      },
    }));
  }

  static get observedAttributes() {
    return ['playing'];
  }

  connectedCallback() {
    if (this.posterElement) {
      this.posterElement.addEventListener('click', this.handlePosterClick.bind(this));
    }

    if (this.autoplay) {
      FoxTheme.Motion?.inView(this, () => {
        if (!this.paused) {
          this.play();
        }

        return () => {
          this.pause();
        };
      });
    }
  }

  handlePosterClick(event) {
    event.preventDefault();
    event.stopPropagation();

    if (this.playing) {
      this.paused = true;
      this.pause();
    } else {
      this.paused = false;
      this.play();
    }
  }

  play() {
    if (!this.playing) {
      this.player.play();
    }
  }

  pause() {
    if (this.playing) {
      this.player.pause();
    }
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'playing') {
      if (oldValue === null && newValue === '') {
        return this.dispatchEvent(new CustomEvent('video:play', { bubbles: true }));
      }

      if (newValue === null) {
        return this.dispatchEvent(new CustomEvent('video:pause', { bubbles: true }));
      }
    }
  }

  initializePlayer() {
    if (this.hasAttribute('source')) {
      this.setAttribute('loaded', '');
      this.closest('.media')?.classList.remove('loading');

      return new Promise(async (resolve) => {
        const templateElement = this.querySelector('template');
        if (templateElement) {
          templateElement.replaceWith(templateElement.content.firstElementChild.cloneNode(true));
        }
        
        const muteVideo = this.hasAttribute('autoplay') || window.matchMedia('screen and (max-width: 1023px)').matches;
        const script = document.createElement('script');
        script.type = 'text/javascript';
        
        if (this.getAttribute('source') === 'youtube') {
          if (!window.YT || !window.YT.Player) {
            script.src = 'https://www.youtube.com/iframe_api';
            document.head.appendChild(script);
            await new Promise(resolve2 => {
              script.onload = resolve2;
            });
          }
          await onYouTubeApiLoaded;
          
          this.iframe = this.querySelector('iframe');
          const player = new YT.Player(this.iframe, {
            events: {
              onReady: () => {
                if (muteVideo) {
                  player.mute();
                }
                resolve(player);
              },
              onStateChange: (event) => {
                if (event.data === YT.PlayerState.PLAYING) {
                  this.setAttribute('playing', '');
                } else if (event.data === YT.PlayerState.ENDED || event.data === YT.PlayerState.PAUSED) {
                  this.removeAttribute('playing');
                }
              },
            },
          });
        }
        
        if (this.getAttribute('source') === 'vimeo') {
          if (!window.Vimeo || !window.Vimeo.Player) {
            script.src = 'https://player.vimeo.com/api/player.js';
            document.head.appendChild(script);
            await new Promise(resolve2 => {
              script.onload = resolve2;
            });
          }
          
          this.iframe = this.querySelector('iframe');
          const player = new Vimeo.Player(this.iframe);
          if (muteVideo) {
            player.setMuted(true);
          }
          player.on('play', () => {
            this.setAttribute('playing', '');
          });
          player.on('pause', () => this.removeAttribute('playing'));
          player.on('ended', () => this.removeAttribute('playing'));
          resolve(player);
        }
      });
    } else {
      this.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));
      this.setAttribute('loaded', '');
      this.closest('.media')?.classList.remove('loading');

      const player = this.querySelector('video');
      player.addEventListener('play', () => {
        this.setAttribute('playing', '');
        this.removeAttribute('suspended');
      });
      player.addEventListener('pause', () => {
        if (!player.seeking && player.paused) {
          this.removeAttribute('playing');
        }
      });
      return player;
    }
  }

  handlePlayerAction(target, prop) {
    if (this.getAttribute('source') === 'youtube') {
      prop === 'play' ? target.playVideo() : target.pauseVideo();
    } else {
      if (prop === 'play' && !this.hasAttribute('source')) {
        target.play().catch(error => {
          if (error.name === 'NotAllowedError') {
            this.setAttribute('suspended', '');
            target.controls = true;
            const replacementImageSrc = target.previousElementSibling?.currentSrc;
            if (replacementImageSrc) {
              target.poster = replacementImageSrc;
            }
          }
        });
      } else {
        target[prop]();
      }
    }
  }

  disconnectedCallback() {
    // 清理视频播放器
    if (this.getAttribute('source') === 'youtube' && this.iframe && window.YT) {
      const player = new YT.Player(this.iframe);
      player.destroy();
    } else if (this.getAttribute('source') === 'vimeo' && this.iframe && window.Vimeo) {
      const player = new Vimeo.Player(this.iframe);
      player.destroy();
    }
  }
}
customElements.define('video-element', VideoElement);

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('.disclosure-list'),
    };

    this.elements.panel?.removeAttribute('hidden');
    this.mediaQueryHandler = null;
  }

  connectedCallback() {
    if (this.elements.button) {
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    }
    
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
    this.querySelectorAll('a').forEach(item => 
      item.addEventListener('click', this.onItemClick.bind(this))
    );

    this.handleDropdownPos();
    
    // 监听窗口大小变化
    this.mediaQueryHandler = FoxTheme.utils.debounce(() => {
      this.handleDropdownPos();
    }, 100);
    window.addEventListener('resize', this.mediaQueryHandler);
  }

  disconnectedCallback() {
    if (this.mediaQueryHandler) {
      window.removeEventListener('resize', this.mediaQueryHandler);
    }
  }

  handleDropdownPos() {
    if (!this.elements.button) return;
    
    const offsetButton = this.elements.button.getBoundingClientRect().right;
    if (window.innerWidth - offsetButton < 220) {
      this.elements.button.nextElementSibling?.classList.add('disclosure-list__right');
    } else {
      this.elements.button.nextElementSibling?.classList.remove('disclosure-list__right');
    }
  }

  hidePanel() {
    if (this.elements.button) {
      this.elements.button.setAttribute('aria-expanded', 'false');
    }
    this.removeAttribute('open');
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    this.elements.button?.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    if (this.elements.input && form) {
      this.elements.input.value = event.currentTarget.dataset.value;
      form.submit();
    }
  }

  openSelector() {
    this.elements.button?.focus();
    this.toggleAttribute('open');
    if (this.elements.button) {
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }
  }

  closeSelector(event) {
    const shouldClose =
      (event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON') ||
      (event.relatedTarget && !event.relatedTarget.classList.contains('disclosure-list__option'));
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel(shouldClose);
    }
  }
}
customElements.define('localization-form', LocalizationForm);

class GridList extends HTMLElement {
  constructor() {
    super();
    this._cachedGridItems = null;
    this._cachedVisibleGridItems = null;
  }

  get gridItems() {
    return (this._cachedGridItems = this._cachedGridItems || this.querySelectorAll('.f-column'));
  }

  get visibleGridItems() {
    return (this._cachedVisibleGridItems = this._cachedVisibleGridItems || 
      this.querySelectorAll('.f-column:not([style])'));
  }

  connectedCallback() {
    if (FoxTheme.config.motionReduced || this.hasAttribute('motion-reduced')) return;

    this.hideGridItems();
    FoxTheme.Motion?.inView(this, this.showGridItems.bind(this), { margin: '0px 0px -50px 0px' });
  }

  hideGridItems() {
    FoxTheme.Motion?.animate(
      this.gridItems,
      { transform: 'translateY(3.5rem)', opacity: 0.01, visibility: 'hidden' },
      { duration: 0 }
    );
  }

  showGridItems() {
    FoxTheme.Motion?.animate(
      this.gridItems,
      { 
        transform: ['translateY(3.5rem)', 'translateY(0)'], 
        opacity: [0.01, 1], 
        visibility: ['hidden', 'visible'] 
      },
      {
        duration: 0.5,
        delay: FoxTheme.config.motionReduced ? 0 : FoxTheme.Motion?.stagger(0.1),
        easing: [0, 0, 0.3, 1],
      }
    );
  }

  reShowVisibleGridItems() {
    FoxTheme.Motion?.animate(
      this.visibleGridItems,
      { 
        transform: ['translateY(3.5rem)', 'translateY(0)'], 
        opacity: [0.01, 1], 
        visibility: ['hidden', 'visible'] 
      },
      { 
        duration: 0.5, 
        delay: FoxTheme.config.motionReduced ? 0 : FoxTheme.Motion?.stagger(0.1), 
        easing: [0, 0, 0.3, 1] 
      }
    );
  }
}
customElements.define('grid-list', GridList);

class AnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.announcementItemsWrapper = this.querySelector('.swiper-wrapper');
    this.carousel = null;
    this._cachedSlideItems = null;
  }

  getNextSlideButton() {
    return this.querySelector('.swiper-button-next');
  }

  getPrevSlideButton() {
    return this.querySelector('.swiper-button-prev');
  }

  get getSlideItems() {
    return (this._cachedSlideItems = this._cachedSlideItems || 
      Array.from(this.announcementItemsWrapper?.children || []));
  }

  isAutoplayEnabled() {
    return this.hasAttribute('autoplay');
  }

  getAutoplaySpeed() {
    return this.hasAttribute('autoplay') ? parseInt(this.getAttribute('autoplay-speed')) * 1000 : 5000;
  }

  connectedCallback() {
    if (FoxTheme.config.motionReduced) return;
    FoxTheme.Motion?.inView(this, this.initializeCarousel.bind(this), { margin: '200px 0px 200px 0px' });
  }

  initializeCarousel() {
    if (this.getSlideItems.length <= 1) return;
    
    this.carousel = new FoxTheme.Carousel(
      this,
      {
        navigation: {
          nextEl: this.getNextSlideButton(),
          prevEl: this.getPrevSlideButton(),
        },
        loop: true,
        autoplay: this.isAutoplayEnabled() ? { 
          delay: this.getAutoplaySpeed(), 
          pauseOnMouseEnter: true 
        } : false,
      },
      [FoxTheme.Swiper.Autoplay]
    );
    
    this.carousel?.init();

    if (Shopify.designMode) {
      this.addEventListener('shopify:block:select', (event) => {
        this.carousel?.slider?.slideToLoop(this.getSlideItems.indexOf(event.target));
      });
    }
  }
}
customElements.define('announcement-bar', AnnouncementBar);

class SelectElement extends HTMLElement {
  constructor() {
    super();
    this.select = null;
  }

  connectedCallback() {
    this.select = this.querySelector('select');
    if (this.select) {
      this.select.addEventListener('change', this.handleSelectChange.bind(this));
      FoxTheme.Motion?.inView(this, this.init.bind(this), { margin: '200px 0px 200px 0px' });
    }
  }

  init() {
    if (!this.select) return;
    
    const style = window.getComputedStyle(this);
    const value = this.select.options[this.select.selectedIndex].text;

    const text = document.createElement('span');
    text.style.fontFamily = style.fontFamily;
    text.style.fontSize = style.fontSize;
    text.style.fontWeight = style.fontWeight;
    text.style.visibility = 'hidden';
    text.style.position = 'absolute';
    text.innerHTML = value;

    document.body.appendChild(text);
    const width = text.clientWidth;

    this.style.setProperty('--width', `${width}px`);
    text.remove();
  }

  handleSelectChange() {
    this.init();
  }
}
customElements.define('select-element', SelectElement);

class ProductRecentlyViewed extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (FoxTheme.config.hasLocalStorage) {
      const productId = parseInt(this.dataset.productId);
      if (isNaN(productId)) return;
      
      const cookieName = 'hypertheme:recently-viewed';
      const items = JSON.parse(window.localStorage.getItem(cookieName) || '[]');

      if (items.includes(productId)) {
        items.splice(items.indexOf(productId), 1);
      }

      items.unshift(productId);
      // 限制存储数量为20个
      window.localStorage.setItem(cookieName, JSON.stringify(items.slice(0, 20)));
    }
  }
}
customElements.define('product-recently-viewed', ProductRecentlyViewed);

class MotionElement extends HTMLElement {
  constructor() {
    super();
    this.animationFrame = null;
  }

  connectedCallback() {
    if (FoxTheme.config.motionReduced) return;

    const parentMotionElement = this.closest('motion-element:not(:scope)');

    if (parentMotionElement) {
      this.waitForParent(parentMotionElement);
    } else {
      this.preInitialize();
      FoxTheme.Motion?.inView(
        this,
        async () => {
          if (!this.isInstant && this.mediaElements) {
            await FoxTheme.utils.imageReady(this.mediaElements);
          }
          this.initialize();
        },
        { 
          margin: '0px 0px -80px 0px',
          amount: 0.5 // 元素50%可见时才触发动画
        }
      );
    }
  }

  waitForParent(parentMotionElement) {
    const checkParent = () => {
      if (parentMotionElement.hasAttribute('data-initialized')) {
        this.preInitialize();
        FoxTheme.Motion?.inView(
          this,
          async () => {
            if (!this.isInstant && this.mediaElements) {
              await FoxTheme.utils.imageReady(this.mediaElements);
            }
            this.initialize();
          },
          { margin: '0px 0px -80px 0px', amount: 0.5 }
        );
      } else {
        setTimeout(checkParent, 50);
      }
    };
    checkParent();
  }

  get isHold() {
    return this.hasAttribute('hold');
  }

  get isInstant() {
    return this.hasAttribute('data-instantly');
  }

  get mediaElements() {
    return Array.from(this.querySelectorAll('img, iframe, svg'));
  }

  get animationType() {
    return this.dataset.motion || 'fade-up';
  }

  get animationDelay() {
    return parseInt(this.dataset.motionDelay || 0) / 1000;
  }

  preInitialize() {
    if (this.isHold) return;
    
    switch (this.animationType) {
      case 'fade-in':
        this.style.visibility = 'hidden';
        FoxTheme.Motion?.animate(this, { opacity: 0.01 }, { duration: 0 });
        break;

      case 'fade-up':
        this.style.visibility = 'hidden';
        FoxTheme.Motion?.animate(this, { transform: 'translateY(2.5rem)', opacity: 0.01 }, { duration: 0 });
        break;

      case 'zoom-in':
        FoxTheme.Motion?.animate(this, { transform: 'scale(0.8)' }, { duration: 0 });
        break;
      case 'zoom-in-lg':
        FoxTheme.Motion?.animate(this, { transform: 'scale(0)' }, { duration: 0 });
        break;

      case 'zoom-out':
        FoxTheme.Motion?.animate(this, { transform: 'scale(1.08)' }, { duration: 0 });
        break;

      case 'zoom-out-sm':
        FoxTheme.Motion?.animate(this, { transform: 'scale(1.03)' }, { duration: 0 });
        break;
    }
  }

  async initialize() {
    if (this.isHold) return;
    this.setAttribute('data-initialized', 'true');

    // 非首屏元素增加延迟，优先保证首屏体验
    const isAboveFold = this.getBoundingClientRect().top < window.innerHeight;
    const delay = isAboveFold ? this.animationDelay : this.animationDelay + 0.1;

    switch (this.animationType) {
      case 'fade-in':
        this.style.visibility = 'visible';
        await FoxTheme.Motion?.animate(
          this,
          { opacity: 1 },
          { duration: 1.5, delay: delay, easing: [0, 0, 0.3, 1] }
        )?.finished;
        break;

      case 'fade-up':
        this.style.visibility = 'visible';
        await FoxTheme.Motion?.animate(
          this,
          { transform: 'translateY(0)', opacity: 1 },
          { duration: 0.5, delay: delay, easing: [0, 0, 0.3, 1] }
        )?.finished;
        break;

      case 'zoom-in':
        await FoxTheme.Motion?.animate(
          this,
          { transform: 'scale(1)' },
          { duration: 1.3, delay: delay, easing: [0, 0, 0.3, 1] }
        )?.finished;
        break;

      case 'zoom-in-lg':
        await FoxTheme.Motion?.animate(
          this,
          { transform: 'scale(1)' },
          { duration: 0.5, delay: delay, easing: [0, 0, 0.3, 1] }
        )?.finished;
        break;

      case 'zoom-out':
        await FoxTheme.Motion?.animate(
          this,
          { transform: 'scale(1)' },
          { duration: 1.5, delay: delay, easing: [0, 0, 0.3, 1] }
        )?.finished;
        break;

      case 'zoom-out-sm':
        await FoxTheme.Motion?.animate(
          this,
          { transform: 'scale(1)' },
          { duration: 1, delay: delay, easing: [0, 0, 0.3, 1] }
        )?.finished;
        break;
    }
  }

  async resetAnimation(duration) {
    switch (this.animationType) {
      case 'fade-in':
        await FoxTheme.Motion?.animate(
          this,
          { opacity: 0 },
          {
            duration: duration ? duration : 1.5,
            delay: this.animationDelay,
            easing: duration ? 'none' : [0, 0, 0.3, 1],
          }
        )?.finished;
        break;

      case 'fade-up':
        await FoxTheme.Motion?.animate(
          this,
          { transform: 'translateY(2.5rem)', opacity: 0 },
          {
            duration: duration ? duration : 0.5,
            delay: this.animationDelay,
            easing: duration ? 'none' : [0, 0, 0.3, 1],
          }
        )?.finished;
        break;

      case 'zoom-in':
        await FoxTheme.Motion?.animate(
          this,
          { transform: 'scale(0)' },
          {
            duration: duration ? duration : 1.3,
            delay: this.animationDelay,
            easing: duration ? 'none' : [0, 0, 0.3, 1],
          }
        )?.finished;
        break;

      case 'zoom-in-lg':
        await FoxTheme.Motion?.animate(
          this,
          { transform: 'scale(0)' },
          {
            duration: duration ? duration : 1.3,
            delay: this.animationDelay,
            easing: duration ? 'none' : [0, 0, 0.3, 1],
          }
        )?.finished;
        break;

      case 'zoom-out':
        await FoxTheme.Motion?.animate(
          this,
          { transform: 'scale(0)' },
          {
            duration: duration ? duration : 1.3,
            delay: this.animationDelay,
            easing: duration ? 'none' : [0.16, 1, 0.3, 1],
          }
        )?.finished;
        break;

      case 'zoom-out-sm':
        await FoxTheme.Motion?.animate(
          this,
          { transform: 'scale(0)' },
          {
            duration: duration ? duration : 1.3,
            delay: this.animationDelay,
            easing: duration ? 'none' : [0.16, 1, 0.3, 1],
          }
        )?.finished;
        break;
    }
  }

  refreshAnimation() {
    this.removeAttribute('hold');
    this.preInitialize();
    setTimeout(() => {
      this.initialize();
    }, 50);
  }

  disconnectedCallback() {
    if (this.animationFrame) {
      cancelAnimationFrame(this.animationFrame);
    }
  }
}
customElements.define('motion-element', MotionElement);

class TabsComponent extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      tabHeader: '[role="tablist"]',
      tabPanels: ['[role="tabpanel"]'],
      tabNavs: ['[role="tab"]'],
      tabNav: '.tabs__nav-js',
    };
    this.domNodes = FoxTheme.utils.queryDomNodes(this.selectors, this);
    this._buttons = null;
    this.selectedIndex = 0;
    this.selectedTab = this.domNodes.tabPanels[this.selectedIndex];
    this.scrollToActiveTab = this.dataset.scrollToActiveTab === 'true';
    this.scrollOffset = 20;
    this.headerEl = document.querySelector('.header-section header[is="sticky-header"]');
    this.tabChange = null;
    this.scrollHandler = null;
  }

  connectedCallback() {
    this.setActiveTab(0);
    this.init();
    
    // 监听窗口大小变化，更新滚动位置
    this.scrollHandler = FoxTheme.utils.debounce(() => {
      if (this.scrollToActiveTab) {
        this.scrollToTop();
      }
    }, 100);
    window.addEventListener('resize', this.scrollHandler);
  }

  disconnectedCallback() {
    if (this.scrollHandler) {
      window.removeEventListener('resize', this.scrollHandler);
    }
  }

  init = () => {
    this.buttons.forEach(tab => {
      tab.addEventListener('click', this.onTabClick.bind(this));
    });
    this.domNodes.tabHeader?.addEventListener('keydown', this.handleKeyDown.bind(this));
    this.setAccessible();
  };

  static get observedAttributes() {
    return ['data-selected'];
  }

  get buttons() {
    return (this._buttons = this._buttons || Array.from(this.domNodes.tabNavs || []));
  }

  getHeaderHeight() {
    let headerHeight = 0;

    if (this.headerEl) {
      const height = Math.round(this.headerEl.offsetHeight);
      if (this.headerEl.isAlwaysSticky) {
        headerHeight = height;
      } else {
        const isSticky = document.body.classList.contains(this.headerEl.classes.pinned);

        if (window.scrollY > this.offsetTop - this.scrollOffset) {
          headerHeight = height;
        }

        if (isSticky && window.scrollY >= this.offsetTop - this.scrollOffset - height) {
          headerHeight = height;
        }
      }
    }

    return headerHeight;
  }

  scrollToTop() {
    let offsetTop = this.offsetTop - this.scrollOffset - this.getHeaderHeight();
    window.scrollTo({ top: offsetTop, behavior: 'smooth' });
  }

  onTabClick(evt) {
    evt.preventDefault();
    const currentTab = evt.currentTarget;
    const index = currentTab ? Number(currentTab.dataset.index) : 0;
    this.setActiveTab(index);

    if (this.scrollToActiveTab) {
      this.scrollToTop();
    }
  }

  setActiveTab = (tabIndex) => {
    const { tabNavs, tabPanels } = this.domNodes;
    if (tabIndex === -1 || !tabNavs || !tabPanels) return;
    
    const newHeader = tabNavs[tabIndex];
    const newTab = tabPanels[tabIndex];
    this.setAttribute('data-selected', tabIndex);

    tabNavs.forEach(nav => nav.setAttribute('aria-selected', false));
    newHeader?.setAttribute('aria-selected', true);

    this.selectedIndex = tabIndex;
    this.selectedTab = newTab;

    this.dispatchEvent(
      new CustomEvent('tabChange', {
        bubbles: true,
        detail: { selectedIndex: tabIndex, selectedTab: newTab },
      })
    );
  };

  setAccessible() {
    const { tabNavs, tabPanels } = this.domNodes;
    if (!tabNavs || !tabPanels) return;
    
    tabNavs.forEach((tab, index) => {
      if (tab.id) tabPanels[index].setAttribute('aria-labelledby', tab.id);
      tab.setAttribute('aria-selected', index === 0);
      tab.setAttribute('data-index', index);
    });
    tabPanels.forEach((panel, index) => {
      if (panel.id) tabNavs[index].setAttribute('aria-controls', panel.id);
      panel.setAttribute('tabindex', 0);
    });
  }

  handleKeyDown(e) {
    const { tabNavs } = this.domNodes;
    if (!tabNavs) return;
    
    if (e.keyCode === 39 || e.keyCode === 37) {
      tabNavs[this.selectedIndex].setAttribute('tabindex', -1);
      
      if (e.keyCode === 39) {
        this.selectedIndex++;
        if (this.selectedIndex >= tabNavs.length) {
          this.selectedIndex = 0;
        }
      } else if (e.keyCode === 37) {
        this.selectedIndex--;
        if (this.selectedIndex < 0) {
          this.selectedIndex = tabNavs.length - 1;
        }
      }

      tabNavs[this.selectedIndex].setAttribute('tabindex', 0);
      tabNavs[this.selectedIndex].focus();
    }
  }

  getSelected() {
    return {
      index: this.selectedIndex,
      element: this.selectedTab,
    };
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data-selected' && oldValue !== null && oldValue !== newValue) {
      const fromButton = this.buttons[parseInt(oldValue)];
      const toButton = this.buttons[parseInt(newValue)];
      
      if (!fromButton || !toButton) return;
      
      this.transition(
        document.getElementById(fromButton.getAttribute('aria-controls')),
        document.getElementById(toButton.getAttribute('aria-controls'))
      );

      this.scrollToActiveButton(toButton);
    }
  }

  scrollToActiveButton(toButton) {
    if (!this.domNodes.tabNav) return;
    
    const containerGap = 15;
    const scrollRect = toButton.getBoundingClientRect();
    const boxRect = this.domNodes.tabNav.getBoundingClientRect();
    const scrollLeft = this.domNodes.tabNav.scrollLeft;
    const scrollOffset = scrollRect.x + scrollLeft - boxRect.x - containerGap;

    this.domNodes.tabNav.scrollTo({
      left: scrollOffset,
      behavior: 'smooth',
    });
  }

  async transition(fromPanel, toPanel) {
    if (!fromPanel || !toPanel) return;
    
    await FoxTheme.Motion?.animate(
      fromPanel,
      { transform: ['translateY(0)', 'translateY(2rem)'], opacity: [1, 0] },
      { duration: 0.3 }
    )?.finished;

    fromPanel.hidden = true;
    toPanel.hidden = false;

    FoxTheme.Motion?.animate(
      toPanel,
      { transform: ['translateY(2rem)', 'translateY(0)'], opacity: [0, 1] },
      { duration: 0.3 }
    )?.finished;

    toPanel.querySelector('grid-list')?.showGridItems();
  }
}
customElements.define('tabs-component', TabsComponent);

class Parallax extends HTMLElement {
  constructor() {
    super();
    this._scrollAnimation = null;
  }

  get parallax() {
    return this.dataset.parallax ? parseFloat(this.dataset.parallax) : false;
  }

  get parallaxDirection() {
    return this.dataset.parallaxDirection || 'vertical';
  }

  get parallaxMediaElements() {
    return Array.from(this.querySelectorAll('img, video, iframe, svg, video-element'));
  }

  connectedCallback() {
    if (this.shouldInitializeParallax()) {
      this.setupParallax();
    }
  }

  disconnectedCallback() {
    // 清理视差动画
    if (this._scrollAnimation) {
      this._scrollAnimation.cancel();
    }
  }

  shouldInitializeParallax() {
    return !FoxTheme.config.motionReduced && this.parallax;
  }

  setupParallax() {
    const parallaxScale = 1 + this.parallax;
    const parallaxTranslate = (this.parallax * 100) / (1 + this.parallax);

    let parallaxTransformProperties = {};

    if (this.parallaxDirection === 'vertical') {
      parallaxTransformProperties = {
        transform: [
          `scale(${parallaxScale}) translateY(0)`,
          `scale(${parallaxScale}) translateY(${parallaxTranslate}%)`,
        ],
        transformOrigin: ['bottom', 'bottom'],
      };
    } else if (this.parallaxDirection === 'horizontal') {
      parallaxTransformProperties = {
        transform: [
          `scale(${parallaxScale}) translateX(0)`,
          `scale(${parallaxScale}) translateX(${parallaxTranslate}%)`,
        ],
        transformOrigin: ['right', 'right'],
      };
    } else {
      parallaxTransformProperties = {
        transform: [`scale(1)`, `scale(${parallaxScale})`],
        transformOrigin: ['center', 'center'],
      };
    }

    // 存储动画引用以便后续清理
    this._scrollAnimation = FoxTheme.Motion?.scroll(
      FoxTheme.Motion?.animate(this.parallaxMediaElements, parallaxTransformProperties, { easing: 'linear' }),
      {
        target: this,
        offset: ['start end', 'end start'],
      }
    );
  }
}
customElements.define('parallax-element', Parallax);

class ProductForm extends HTMLFormElement {
  constructor() {
    super();
    this.productIdInput = this.querySelector('[name=id]');
    if (this.productIdInput) {
      this.productIdInput.disabled = false;
    }
    this._submitButtonElement = null;
    this.lastSubmittedElement = null;
    this.formErrorMessage = null;
    this.hasError = false;
  }

  connectedCallback() {
    this.addEventListener('submit', this.handleFormSubmit);
  }

  disconnectedCallback() {
    this.removeEventListener('submit', this.handleFormSubmit);
  }

  get cartDrawerElement() {
    return document.querySelector('cart-drawer');
  }

  get submitButtonElement() {
    return (this._submitButtonElement = this._submitButtonElement || this.querySelector('[type="submit"]'));
  }

  get isHideErrors() {
    return this.dataset.hideErrors === 'true';
  }

  handleFormSubmit = (event) => {
    if (FoxTheme.settings?.cartType === 'page') return;

    event.preventDefault();
    if (this.submitButtonElement?.getAttribute('aria-disabled') === 'true') return;
    this.lastSubmittedElement = event.submitter || event.currentTarget;

    this.displayFormErrors();

    let sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
    );

    const config = FoxTheme.utils.fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    this.formData = new FormData(this);
    this.formData.append('sections', sectionsToBundle);
    this.formData.append('sections_url', window.location.pathname);

    config.body = this.formData;

    this.submitButtonElement?.setAttribute('aria-disabled', 'true');
    this.submitButtonElement?.classList.add('btn--loading');

    this.handleFormSubmission(config);
  };

  displayFormErrors = (errorMessage = false) => {
    if (this.isHideErrors) return;

    this.formErrorMessage = this.formErrorMessage || this.querySelector('.product-form__error-message');
    if (!this.formErrorMessage) {
      if (errorMessage !== false) {
        alert(errorMessage);
      }
    } else {
      this.formErrorMessage.toggleAttribute('hidden', !errorMessage);
      if (errorMessage !== false) {
        this.formErrorMessage.innerText = errorMessage;
      }
    }
  };

  resetFormState() {
    this.hasError = false;
    this.submitButtonElement?.removeAttribute('aria-disabled');
    this.displayFormErrors();
  }

  handleFormSubmission = (config) => {
    fetch(`${FoxTheme.routes?.cart_add_url || '/cart/add'}`, config)
      .then(response => response.json())
      .then(async (parsedState) => {
        if (parsedState.status) {
          this.handleCartError(parsedState);
          return;
        }

        try {
          const cartResponse = await fetch(`${FoxTheme.routes?.cart_url || '/cart.json'}`, { 
            ...FoxTheme.utils.fetchConfig() 
          });
          const cartJson = await cartResponse.json();
          cartJson['sections'] = parsedState['sections'];
          this.updateCartState(cartJson);
          this.dispatchProductAddedEvent(parsedState);
          this.showCartDrawer();
        } catch (error) {
          console.error('Failed to fetch cart data:', error);
          this.handleCartError({ description: 'Failed to update cart' });
        }
      })
      .catch((error) => {
        console.error('Form submission error:', error);
        this.handleCartError({ description: 'An error occurred while adding to cart' });
      })
      .finally(() => {
        this.submitButtonElement?.classList.remove('btn--loading');
        this.submitButtonElement?.removeAttribute('aria-disabled');
      });
  };

  handleCartError = (parsedState) => {
    FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartError, {
      source: 'product-form',
      productVariantId: this.formData?.get('id'),
      errors: parsedState.errors || parsedState.description,
      message: parsedState.message,
    });
    this.displayFormErrors(parsedState.description);
    document.dispatchEvent(
      new CustomEvent('product-ajax:error', {
        detail: {
          errorMessage: parsedState.description,
        },
      })
    );
    this.hasError = true;
  };

  updateCartState = (cartJson) => {
    FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
  };

  dispatchProductAddedEvent = (parsedState) => {
    document.dispatchEvent(
      new CustomEvent('product-ajax:added', {
        detail: {
          product: parsedState,
        },
      })
    );
  };

  showCartDrawer = () => {
    const quickViewModal = this.closest('quick-view-modal');
    if (quickViewModal) {
      if (this.cartDrawerElement && !this.cartDrawerElement.open) {
        document.body.addEventListener(
          quickViewModal.events.handleAfterHide,
          () => {
            setTimeout(() => {
              this.cartDrawerElement.show(this.lastSubmittedElement);
            });
          },
          { once: true }
        );
      }

      quickViewModal.hide(true);
    } else {
      this.cartDrawerElement?.show(this.lastSubmittedElement);
    }
  };
}
customElements.define('product-form', ProductForm, { extends: 'form' });

class NewsletterForm extends HTMLFormElement {
  constructor() {
    super();
    this.selectors = {
      subscribedMessage: '[id*=Newsletter-error-subscribed]',
      modal: '[id*=NewsletterAlertModal-]',
    };
    this.init();
  }

  init() {
    const liveUrl = window.location.href;
    const result = liveUrl.includes('form_type=customer');
    const input = this.querySelector('[id*="NewsletterForm"]');
    const inputVal = input ? input.value.length : 0;
    const modalEl = this.querySelector(this.selectors.modal);

    if (result && inputVal !== 0) {
      const messageElement = this.querySelector(this.selectors.subscribedMessage);
      messageElement?.classList.remove('hidden');
      if (!window.isNewsletterModalShow) {
        modalEl?.show();
        window.isNewsletterModalShow = true;
      }
    }

    const alertEl = this.querySelector('.form-message--main');
    if (alertEl && !window.isNewsletterModalShow) {
      modalEl?.show();
      window.isNewsletterModalShow = true;
    }
  }
}
customElements.define('newsletter-form', NewsletterForm, { extends: 'form' });

class ColorSwatch extends HTMLUListElement {
  constructor() {
    super();
    this.selectors = {
      card: '.product-card',
      mainImg: '.product-card__image--main img',
      swatches: '.swatch-item',
      variantImg: '.color-swatch--variant-image',
    };
    this.hoverTracker = null;
    this.optionNodes = null;
    this.abortController = null;
    this.pcard = null;
    this.mainImage = null;
    this.selected = null;
  }

  connectedCallback() {
    this.optionNodes = this.querySelectorAll(this.selectors.swatches);
    this.init();
  }

  disconnectedCallback() {
    if (this.abortController) {
      this.abortController.abort();
    }
  }

  init() {
    this.abortController = new AbortController();
    this.pcard = this.closest(this.selectors.card);
    this.mainImage = this.pcard?.querySelector(this.selectors.mainImg);

    this.optionNodes.forEach(button => {
      button.addEventListener('mouseenter', this.onMouseEnter.bind(this), {
        signal: this.abortController.signal,
      });
    });
  }

  onMouseEnter(e) {
    const { target } = e;
    const variantImage = target.querySelector(this.selectors.variantImg);

    clearTimeout(this.hoverTracker);
    this.hoverTracker = setTimeout(() => {
      this.selected?.removeAttribute('aria-selected');
      target.setAttribute('aria-selected', true);
      this.selected = target;

      if (this.mainImage && variantImage) {
        this.mainImage.src = variantImage.src;
        this.mainImage.srcset = variantImage.srcset;
      }
    }, 50);
  }
}
customElements.define('color-swatch', ColorSwatch, { extends: 'ul' });

class ScrollingPromotion extends HTMLElement {
  constructor() {
    super();
    this.promotion = this.querySelector('.promotion');
    this.repeatTimes = typeof this.dataset.repeats !== 'undefined' ? Number(this.dataset.repeats) : 10;
    this.observer = null;
  }

  connectedCallback() {
    if (FoxTheme.config.motionReduced) return;
    FoxTheme.Motion?.inView(this, this.init.bind(this), { margin: '200px 0px 200px 0px' });
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  init() {
    if (this.childElementCount === 1 && this.promotion) {
      this.promotion.classList.add('promotion--animated');

      // 限制复制次数，避免过多DOM元素
      const safeRepeatTimes = Math.min(this.repeatTimes, 10);
      for (let index = 0; index < safeRepeatTimes; index++) {
        const clone = this.promotion.cloneNode(true);
        this.appendChild(clone);
      }

      // 视口外暂停动画
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.scrollingPlay();
            } else {
              this.scrollingPause();
            }
          });
        },
        { rootMargin: '0px 0px 50px 0px' }
      );

      this.observer.observe(this);
    }
  }

  scrollingPlay() {
    this.classList.remove('scrolling-promotion--paused');
  }

  scrollingPause() {
    this.classList.add('scrolling-promotion--paused');
  }
}
customElements.define('scrolling-promotion', ScrollingPromotion);

class ReadMore extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      content: '.read-more__content',
      button: '.read-more__toggle',
      buttonText: '.btn__text',
    };

    this.classes = {
      isDisabled: 'is-disabled',
      isCollapsed: 'is-collapsed',
    };

    this.abortController = null;
    this.toggleClass = this.dataset.toggleClass;
    this.showText = this.dataset.showText;
    this.hideText = this.dataset.hideText;
    this.lineClamp = parseInt(this.dataset.lineClamp) || 3;
    this.buttonEl = this.querySelector(this.selectors.button);
    this.contentEl = this.querySelector(this.selectors.content);
    this.mediaQueryHandler = null;
  }

  connectedCallback() {
    this.abortController = new AbortController();

    if (this.buttonEl && this.contentEl) {
      this.buttonEl.addEventListener('click', this.onClick.bind(this), {
        signal: this.abortController.signal,
      });
    }

    this.init();

    // 监听窗口大小变化
    this.mediaQueryHandler = FoxTheme.utils.debounce(() => {
      this.init();
    }, 100);
    window.addEventListener('resize', this.mediaQueryHandler);
  }

  disconnectedCallback() {
    if (this.abortController) {
      this.abortController.abort();
    }
    if (this.mediaQueryHandler) {
      window.removeEventListener('resize', this.mediaQueryHandler);
    }
  }

  init() {
    if (!this.contentEl) return;
    
    const lineHeight = parseFloat(window.getComputedStyle(this.contentEl).lineHeight) || 1.5;
    const contentHeight = this.contentEl.scrollHeight;
    const maxHeight = lineHeight * this.lineClamp;

    if (this.buttonEl) {
      this.buttonEl.style.display = contentHeight <= maxHeight ? 'none' : '';
    }

    if (contentHeight <= maxHeight) {
      return;
    }

    this.classList.remove(this.classes.isDisabled);
    this.contentEl.classList.remove(this.toggleClass);
    this.showLess();
  }

  showMore() {
    if (!this.contentEl) return;
    
    this.contentEl.classList.remove(this.toggleClass);
    this.classList.remove(this.classes.isCollapsed);
    this.buttonEl?.querySelector(this.selectors.buttonText)?.setAttribute('textContent', this.hideText);
    this.resetHeight();
  }

  showLess() {
    if (!this.contentEl) return;
    
    this.contentEl.classList.add(this.toggleClass);
    this.classList.add(this.classes.isCollapsed);
    this.buttonEl?.querySelector(this.selectors.buttonText)?.setAttribute('textContent', this.showText);
    this.setHeight();
  }

  setHeight() {
    if (!this.contentEl) return;
    
    const lineHeight = parseFloat(window.getComputedStyle(this.contentEl).lineHeight) || 1.5;
    const lines = parseInt(window.getComputedStyle(this.contentEl).getPropertyValue('--line-clamp')) || this.lineClamp;
    const maxHeight = lineHeight * lines;
    this.contentEl.style.setProperty('max-height', maxHeight + 'px');
  }

  resetHeight() {
    this.contentEl?.style.removeProperty('max-height');
  }

  onClick(evt) {
    evt.preventDefault();
    if (!this.contentEl) return;
    
    if (this.contentEl.classList.contains(this.toggleClass)) {
      this.showMore();
    } else {
      this.showLess();
    }
  }
}
customElements.define('read-more', ReadMore);

class CopyToClipboard extends HTMLDivElement {
  constructor() {
    super();
    this.classes = {
      copied: 'tooltip--is-visible',
    };
    this.clickHandler = this.onClick.bind(this);
    this.clickTracker = null;
  }

  get button() {
    return this.querySelector('button');
  }

  connectedCallback() {
    if (this.button) {
      this.button.addEventListener('click', this.clickHandler);
    }
  }

  disconnectedCallback() {
    if (this.button) {
      this.button.removeEventListener('click', this.clickHandler);
    }
    clearTimeout(this.clickTracker);
  }

  onClick(event) {
    event.preventDefault();
    const valueToCopy = this.dataset.copyValue;
    if (!valueToCopy) return;

    try {
      navigator.clipboard.writeText(valueToCopy);
      this.classList.add(this.classes.copied);
      clearTimeout(this.clickTracker);
      this.clickTracker = setTimeout(() => {
        this.classList.remove(this.classes.copied);
      }, 3000);
    } catch (error) {
      console.warn('Failed to copy to clipboard:', error);
    }
  }
}
customElements.define('copy-to-clipboard', CopyToClipboard, { extends: 'div' });

class ScrollProgressBar extends HTMLElement {
  constructor() {
    super();
    this.mediaQuery = null;
    this.resizeObserver = null;
    this.scrollHandler = null;
    this.mediaQueryHandler = null;
  }

  get totalWidth() {
    return this.contentContainer?.offsetWidth || 0;
  }

  get targetId() {
    return this.getAttribute('target');
  }

  get target() {
    return document.getElementById(this.targetId);
  }

  get targetScrollLeft() {
    return this.target?.scrollLeft || 0;
  }

  set targetScrollLeft(value) {
    if (this.target) {
      this.target.scrollLeft = value;
    }
  }

  connectedCallback() {
    this.mediaQuery = window.matchMedia(FoxTheme.config.mediaQueryMobile);
    this.resizeObserver = new ResizeObserver(() => {
      if (this.mediaQuery.matches) {
        this.init();
      }
    });

    this.mediaQueryHandler = (event) => {
      if (event.matches) {
        this.init();
      } else {
        this.disable();
      }
    };

    this.mediaQuery.addEventListener('change', this.mediaQueryHandler);

    if (!this.mediaQuery.matches) {
      this.disable();
      return;
    }

    this.init();
  }

  disconnectedCallback() {
    this.mediaQuery?.removeEventListener('change', this.mediaQueryHandler);
    this.resizeObserver?.disconnect();
    this.disable();
  }

  init() {
    if (!this.target) {
      console.error('Target element not found for scroll progress bar');
      return;
    }

    this.contentContainer = this.target.children[0];
    this.progressBar = this.querySelector('.progress-bar');

    const targetStyle = window.getComputedStyle(this.target);
    this.targetPadding = parseFloat(targetStyle.paddingLeft) + parseFloat(targetStyle.paddingRight);

    this.resizeObserver.observe(this.target);

    const viewportWidth = this.target.clientWidth - this.targetPadding;

    if (this.totalWidth <= viewportWidth) {
      this.disable();
      return;
    }

    this.calculateInitialProgress();

    this.scrollHandler = () => {
      requestAnimationFrame(() => this.updateProgress());
    };
    this.target.addEventListener('scroll', this.scrollHandler);

    this.style.display = 'block';
    this.updateProgress();
  }

  disable() {
    if (this.scrollHandler && this.target) {
      this.target.removeEventListener('scroll', this.scrollHandler);
    }

    this.style.display = 'none';

    if (this.progressBar) {
      this.progressBar.style.width = '0%';
    }

    if (this.target) {
      this.resizeObserver.unobserve(this.target);
    }
  }

  calculateInitialProgress() {
    const viewportWidth = this.target.clientWidth - this.targetPadding;
    this.initialProgress = (viewportWidth / this.totalWidth) * 100;
    this.updateProgress();
  }

  updateProgress() {
    if (!this.progressBar || !this.target) return;
    
    const factor = FoxTheme.config.isRTL ? -1 : 1;
    const viewportWidth = this.target.clientWidth - this.targetPadding;
    const scrolled = factor * this.targetScrollLeft;
    const maxScroll = this.totalWidth - viewportWidth;

    if (maxScroll <= 0) {
      this.progressBar.style.width = '100%';
      return;
    }

    const scrollProgress = (scrolled / maxScroll) * (100 - this.initialProgress);
    const totalProgress = this.initialProgress + scrollProgress;

    const clampedProgress = Math.min(100, Math.max(this.initialProgress, totalProgress));

    this.progressBar.style.width = `${clampedProgress}%`;
  }
}

customElements.define('scroll-progress-bar', ScrollProgressBar);

class ScrollPagination extends ScrollProgressBar {
  constructor() {
    super();
    this.columns = [];
    this.columnWidth = 0;
  }

  get columns() {
    return this.target?.querySelectorAll('.swipe-mobile__inner > .f-column:not(.hidden)') || [];
  }

  disable() {
    super.disable();

    const prevBtn = this.querySelector('.scroll-pagination__prev');
    const nextBtn = this.querySelector('.scroll-pagination__next');
    
    if (prevBtn) {
      prevBtn.removeEventListener('click', this.handleDecreaseScroll.bind(this));
    }
    if (nextBtn) {
      nextBtn.removeEventListener('click', this.handleIncreaseScroll.bind(this));
    }
  }

  init() {
    super.init();
    this.columns = this.target?.querySelectorAll('.swipe-mobile__inner > .f-column:not(.hidden)') || [];
    this.columnWidth = this.columns[0]?.offsetWidth || 0;

    const prevBtn = this.querySelector('.scroll-pagination__prev');
    const nextBtn = this.querySelector('.scroll-pagination__next');
    
    if (prevBtn) {
      prevBtn.addEventListener('click', this.handleDecreaseScroll.bind(this));
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', this.handleIncreaseScroll.bind(this));
    }
  }

  handleDecreaseScroll(e) {
    if (this.targetScrollLeft <= this.columnWidth) {
      e.preventDefault();
      return;
    }

    this.targetScrollLeft -= this.columnWidth;
  }

  handleIncreaseScroll(e) {
    if (this.targetScrollLeft >= this.totalWidth - this.target.clientWidth) {
      e.preventDefault();
      return;
    }

    this.targetScrollLeft += this.columnWidth;
  }

  updateProgress() {
    super.updateProgress();
    const current = Math.round(this.targetScrollLeft / this.columnWidth) + 1;
    const currentEl = this.querySelector('.scroll-pagination__current');
    if (currentEl) {
      currentEl.innerText = current;
    }
  }
}
